import { render, staticRenderFns } from "./studentPlane.vue?vue&type=template&id=21a1b670&scoped=true"
import script from "./studentPlane.vue?vue&type=script&lang=js"
export * from "./studentPlane.vue?vue&type=script&lang=js"
import style0 from "./studentPlane.vue?vue&type=style&index=0&id=21a1b670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1b670",
  null
  
)

export default component.exports